<template>
    <v-card>
        <v-card-title class="headline">Khóa xe {{vehicle.plate}}?</v-card-title>
        <v-card-text>
            <v-form v-model="lockVehicleForm.isValid" ref="lockVehicleForm">
                Vui lòng nhập lý do khóa xe {{vehicle.plate}}
                <v-textarea
                    v-model="lockVehicleForm.remark"
                    label="Lý do khóa xe"
                    :rules="[validate.required]"
                ></v-textarea>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="$emit('show', false)">Từ chối</v-btn>
            <v-btn
                flat
                color="primary"
                @click.native="deleteVehicleSubmit()"
                :loading="lockVehicleForm.isLoading"
            >Đồng ý</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import validate from '@/utils/validate';

export default {
  props: {
    vehicle: Object
  },
  data () {
    return {
      validate: validate,
      lockVehicleForm: {
        isValid: false,
        isLoading: false,
        remark: ''
      },
    };
  },
  methods: {
    ...mapActions(['lockDevice']),

    deleteVehicleSubmit () {
      if (this.lockVehicleForm.isValid) {
        this.lockVehicleForm.isLoading = true;
        this.lockDevice({
          vehicleId: this.vehicle.id,
          remark: this.lockVehicleForm.remark
        })
          .then(res => {
            this.lockVehicleForm.isLoading = false;
            this.$emit('show', false);
            window.getApp.showMessage(
              `Khóa xe ${this.vehicle.plate} thành công`
            );
            setTimeout(() => {
              window.location.reload();
            }, 500);
          })
          .catch(_ => {
            this.lockVehicleForm.isLoading = false;
            window.getApp.showMessage(
              'Khóa xe thất bại, vui lòng thử lại',
              'error'
            );
          });
      } else {
        this.$refs.lockVehicleForm.validate();
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/vehicle/components/Lock.vue